// src/components/transactions/components/RecurringTransactionDetails.tsx

import React from "react";
import { Modal } from "flowbite-react";
import { RecurringTransaction } from "../../../domain/types/RecurringTransaction";
import { formatCurrency } from "../utils/transactionFormatters";
import { HiOutlineArrowUp, HiOutlineArrowDown } from "react-icons/hi2";

interface RecurringTransactionDetailsProps {
  transaction: RecurringTransaction;
  onClose: () => void;
}

export const RecurringTransactionDetails: React.FC<
  RecurringTransactionDetailsProps
> = ({ transaction, onClose }) => {
  return (
    <Modal show onClose={onClose} size="lg" dismissible={true}>
      <Modal.Header>Recurring Transaction Details</Modal.Header>
      <Modal.Body className="space-y-6">
        {/* Transaction Type */}
        <div className="flex items-center">
          {transaction.stream_type === "inflow" ? (
            <HiOutlineArrowDown className="w-6 h-6 text-green-600" />
          ) : (
            <HiOutlineArrowUp className="w-6 h-6 text-red-600" />
          )}
          <h3 className="text-lg font-semibold ml-2">
            {transaction.merchant_name || transaction.description}
          </h3>
        </div>

        {/* Details */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <DetailItem
            label="Description"
            value={transaction.description || "N/A"}
          />
          <DetailItem
            label="Merchant"
            value={transaction.merchant_name || "Unknown"}
          />
          <DetailItem
            label="Frequency"
            value={transaction.frequency || "N/A"}
          />
          <DetailItem
            label="Average Amount"
            value={formatCurrency(
              transaction.average_amount.amount,
              transaction.average_amount.iso_currency_code ||
                transaction.average_amount.unofficial_currency_code ||
                "USD",
            )}
          />
          <DetailItem
            label="Last Amount"
            value={formatCurrency(
              transaction.last_amount.amount,
              transaction.last_amount.iso_currency_code ||
                transaction.last_amount.unofficial_currency_code ||
                "USD",
            )}
          />
          <DetailItem
            label="Next Date"
            value={
              transaction.predicted_next_date
                ? new Date(transaction.predicted_next_date).toLocaleDateString()
                : "N/A"
            }
          />
          <DetailItem
            label="First Date"
            value={
              transaction.first_date
                ? new Date(transaction.first_date).toLocaleDateString()
                : "N/A"
            }
          />
          <DetailItem
            label="Last Date"
            value={
              transaction.last_date
                ? new Date(transaction.last_date).toLocaleDateString()
                : "N/A"
            }
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

const DetailItem: React.FC<{ label: string; value: string }> = ({
  label,
  value,
}) => (
  <div>
    <div className="text-sm text-gray-500 dark:text-gray-400">{label}</div>
    <div className="text-base text-gray-800 dark:text-gray-200">{value}</div>
  </div>
);
